import type { WebPushTransport } from "@/lib/web-push-browser";

export function isWebPushTransportEnabled(
  transports: { apns: boolean; fcm: boolean } | undefined,
  transport: WebPushTransport,
) {
  return transports?.[transport] === true;
}
